<template>
  <div class="container1400">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="2" align-self="center">
          <router-link class="navbar-brand" to="/">
            <v-img
              src="../../assets/images/logo-icon.png"
              alt="Nomad Rooms"
              class="shrink mr-2"
              contain
              transition="scale-transition"
              width="36"
            />
          </router-link>
        </v-col>
        <v-col cols="6">
          <v-form
            ref="form"
            class="mx-auto"
            style="max-width: 500px"
            @submit.prevent="submit"
          >
            <v-row no-gutters>
              <v-col cols="12" md="10">
                <v-autocomplete
                  solo
                  no-filter
                  hide-details="auto"
                  v-model="location"
                  :loading="loading"
                  :rules="reqRules"
                  :items="entries"
                  :search-input.sync="search"
                  item-text="locale_names"
                  disable-lookup
                  v-bind:placeholder="$t('TypeYourDestination')"
                  return-object
                  hide-no-data
                >
                  <template v-slot:item="data">
                    <v-list-item-avatar>
                      <v-icon color="light-blue">mdi-map-marker-radius</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.locale_names"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:append-item>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item
                      v-for="pro in properties"
                      :key="pro._id"
                      :to="{
                        name: 'GuestViewListing',
                        params: { id: pro._id }
                      }"
                    >
                      <v-list-item-avatar
                        v-for="(pic, i) in pro.pictures"
                        :key="i"
                      >
                        <v-img
                          :alt="`${pro.name} avatar`"
                          :src="
                            $store.state.baseUrl +
                              'listing/thumb320x240-' +
                              pic.file_name
                          "
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ pro.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ pro.location }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn
                  block
                  depressed
                  x-large
                  height="48px"
                  class="light-blue white--text homeSearch"
                  @click="submit"
                >
                  <v-icon small>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-col cols="4" align-self="center">
          <div class="float-right">
            <CurrencySelectorComponent />
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" color="light-blue">
                  <v-icon>mdi-web</v-icon>{{ $i18n.locale }}
                </v-btn>
              </template>
              <v-list v-model="$i18n.locale">
                <v-list-item v-for="(item, i) in items" :key="i">
                  <v-list-item-title>
                    <v-btn text @click="changeLocale(item.code)">
                      {{ item.title }}
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y left z-index="5000">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  rounded
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  color="light-blue"
                >
                  <v-icon color="grey" small>mdi-menu</v-icon>
                  <v-icon
                    v-if="!$store.state.user.profilePic"
                    color="light-blue"
                    class="ml-2"
                    >mdi-account-circle</v-icon
                  >
                  <v-avatar
                    class="ml-2"
                    v-if="$store.state.user.profilePic"
                    size="25"
                  >
                    <img
                      :src="$store.state.baseUrl + $store.state.user.profilePic"
                      alt="Dashboard"
                    />
                  </v-avatar>
                </v-btn>
              </template>
              <v-list dense min-width="200px">
                <v-list-item
                  href="https://member.nomadrooms.com/"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-open-in-new</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ $t("About") }} Nomad</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="$store.getters.isLoggedIn"
                  to="/dashboard"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-view-dashboard</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Dashboard") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  to="/listing/add"
                  v-if="$store.getters.isLoggedIn"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-home-city-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      ><span v-if="$store.state.user.role === 'Host'">{{
                        $t("AddNewProperty")
                      }}</span>
                      <span v-else>{{
                        $t("BecomeaPartner")
                      }}</span></v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="!$store.getters.isLoggedIn"
                  to="/register?redirect=/listing/add"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-home-city-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("BecomeaPartner")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="!$store.getters.isLoggedIn"
                  to="/login"
                  color="light-blue"
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-login</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("Login") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="$store.getters.isLoggedIn" @click="logout">
                  <v-list-item-icon class="mr-3">
                    <v-icon small>mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("LogOut") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { loadLanguageAsync } from "@/plugins/i18n";
import ListingService from "@/services/ListingService";
import CurrencySelectorComponent from "@/components/layout/CurrencySelectorComponent.vue";

export default {
  name: "FullHeaderComponent",
  components: { CurrencySelectorComponent },
  data() {
    return {
      cities: [],
      list: [],
      search: null,
      loading: false,
      location: null,
      dialog: false,
      prefered_currency: this.$store.state.user.prefered_currency,
      reqRules: [value => !!value || this.$t("string719")],
      items: [
        { title: "English", code: "en", alpha: "us" },
        { title: "Japanese", code: "ja", alpha: "jp" }
      ]
    };
  },
  watch: {
    search(val) {
      val && val.length > 3 && val !== this.select && this.citySelections(val);
    }
  },
  computed: {
    entries() {
      return this.cities.map(e => {
        const locale_names = e.place_name;
        const lat = e.center[1];
        const lng = e.center[0];
        return Object.assign({}, { locale_names, lat, lng });
      });
    },
    properties() {
      return this.list.map(e => {
        if (e._id) {
          return e;
        }
      });
    }
  },
  methods: {
    async citySelections(val) {
      if (val) {
        await ListingService.citySearch({
          query: val
        })
          .then(result => {
            this.cities = result.data.features;
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
        await ListingService.searchLocation({ text: val }).then(result => {
          this.list = result.data.list;
        });
      }
    },
    changeLocale(val) {
      loadLanguageAsync(val);
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "Login" });
      });
    },
    async submit() {
      await this.$refs.form.validate();
      if (this.location) {
        this.$store.dispatch("setSearchQuery", this.location);
        this.$router.push({ name: "SearchListing" });
      }
    }
  }
};
</script>

<style>
.unread {
  font-weight: bold;
  background: #f1f1f1;
}
.on-header.white-input .algolia-places input {
  height: 48px;
  padding-left: 20px;
  font-size: 16px;
}
.on-header .ap-input-icon.ap-icon-pin {
  display: none !important;
}
</style>
